export default __webpack_public_path__ + "static/media/background.1c314463.jpg";